// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"58cbb07f","319":"6cf42289","390":"3deb080a","391":"a0634e6b","449":"986af044","488":"a6333b5e","564":"98a411c3","647":"9eaef3a0","693":"74d1e7a7","798":"484283bb","808":"f202d6e1","974":"db81bcb3"}[chunkId] + ".chunk.js";
};